import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SUBJECT_TYPE, MAX_PROGRESS, STUDY_STATE, DIFFICULTY, SUBJECT_KBN, LIMITED_SUBJECT_SET, ENGLISH_INDEX } from '../../common/constants.js';
import bookmark_off from '../../components/atoms/data/btn_bookmark_off.svg';
import bookmark_on from '../../components/atoms/data/btn_bookmark_on.svg';
import source_nikkei from '../../components/atoms/data/nikkei-book.svg';
import source_alc from '../../components/atoms/data/alc-book.svg';
import source_alfa from '../../components/atoms/data/alpha-book.svg';
import source_org from '../../components/atoms/data/original-book.svg';
import english_america from '../../components/atoms/data/us-flag.svg';
import english_england from '../../components/atoms/data/uk-flag.svg';
import english_australia from '../../components/atoms/data/aus-flag.svg';

/*
 */
class Subject extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    setTimeOutId = 0;

    componentDidMount() {
        this.setTimeOutId = setTimeout(() => {
            this.ref.current.style.opacity = "1";
            this.ref.current.style.marginTop = "5px";
        }, 10);
    }

    componentWillUnmount() {
        clearTimeout(this.setTimeOutId);
    }

    createProgressBar() {
        let ret = [];
        let current = 0;
        let studyState = 0;
        if (this.props.subject.userStatus) {
            studyState = this.props.subject.userStatus.studyState;
            if(studyState === 1){
                current = MAX_PROGRESS;
            }else{
                current = studyState - 1;
            }
        }
        for(let i = 0; i < MAX_PROGRESS; i++){
            if(i < current){
                ret.push(
                    <Bar key={i} color='#00b050'></Bar >
                );
            } else {
                ret.push(
                    <Bar key={i}></Bar >
                );
            }
        }

        return ret;
    }

    createDifficulty() {
        let difficulty = this.props.subject.difficulty;
        let level;
        if(difficulty === 1){
            level = DIFFICULTY[1];
        }else if(difficulty === 2){
            level = DIFFICULTY[2];
        }else if(difficulty === 3){
            level = DIFFICULTY[3];
        }else {
            level = '';
        }
        return level;
    }

    createSource() {
        let source = this.props.subject.source;
        let sourceImg;
        if(source === 1){
            sourceImg = <img src={source_nikkei} alt="img" width="90px" height="24px" />;
        }else if(source === 2){
            sourceImg = <img src={source_alc} alt="img" width="90px" height="24px" />;
        }else if(source === 3){
            sourceImg = <img src={source_alfa} alt="img" width="90px" height="24px" />;
        }else if(source === 4){
            sourceImg = <img src={source_org} alt="img" width="90px" height="24px" />;
        }else{
            sourceImg = "";
        }
        return sourceImg;
    }

    createEnglish(english) {
        let englishImg;
        if(english === ENGLISH_INDEX.AMERICAN_ENGLISH){
            englishImg = <img src={english_america} alt="img" width="35px" height="24px" />;
        }else if(english === ENGLISH_INDEX.BRITISH_ENGLISH){
            englishImg = <img src={english_england} alt="img" width="35px" height="24px" />;
        }else if(english === ENGLISH_INDEX.AUSTRALIAN_ENGLISH){
            englishImg = <img src={english_australia} alt="img" width="35px" height="24px" />;
        }else{
            englishImg = "";
        }
        return englishImg;
    }

    render(){
        const englishList = String(this.props.subject.english).split(",");
        let audio;
        if(this.props.subject.audio !== "") {
            audio = this.props.subject.audio;
        } else {
            audio = "設定なし";
        }
        let iconEye;
        let colorEye;
        if(this.props.subject.releaseFlg) {
            iconEye = <i className="fas fa-eye"/>
            colorEye = "#0077FF";
        } else {
            iconEye = <i className="fas fa-eye-slash"/>
            colorEye = "#888";
        }
        let studyState = 0;
        if (this.props.subject.userStatus) {
            studyState = this.props.subject.userStatus.studyState;
        }
        let favIconImage = <img src={bookmark_off} alt="img" width="32px" height="48px" />
        if (this.props.subject.userStatus && this.props.subject.userStatus.favFlg) {
            favIconImage = <img src={bookmark_on} alt="img" width="32px" height="48px" />
        }

        return(
            <Body ref={this.ref}
                onClick={this.props.onClick}
                active={this.props.active}
                select={this.props.select}
                studyState={studyState}>

                <Training admin={this.props.admin}>
                    {this.createProgressBar()}
                </Training>

                <GroupGrid>
                    <GroupAdmin admin={this.props.admin}>
                        <Type admin={this.props.admin}>
                            {SUBJECT_TYPE[this.props.subject.type]+"難易度"}
                        </Type>
                        <Controls admin={this.props.admin}>
                            <IconButton onClick={this.props.onClickEdit}><i className="fas fa-pen" /></IconButton>
                            <IconButton onClick={this.props.onClickDelete}><i className="fas fa-trash" /></IconButton>
                            <IconButton onClick={this.props.onClickHidden} Color={colorEye}>{iconEye}</IconButton>
                        </Controls>
                    </GroupAdmin>
                    <GroupAllA admin={this.props.admin}>
                        {Number(this.props.subjectKbn) === Number(SUBJECT_KBN.LIMITED) && (
                            <LimitedSubjectSetInfo>
                                {LIMITED_SUBJECT_SET[this.props.subject.limitedSubjectSet]}
                            </LimitedSubjectSetInfo>
                        )}
                        {this.props.subject.title}
                    </GroupAllA>
                    <GroupAllB admin={this.props.admin}>
                        <LanguageInfo>
                            {
                                Number(this.props.subjectKbn) !== Number(SUBJECT_KBN.LIMITED) && (
                                    <>
                                        <Difficulty>
                                            {this.createDifficulty()}
                                        </Difficulty>
                                        <Source>
                                            {this.createSource()}
                                        </Source>
                                    </>
                                )
                            }
                            {
                                englishList.length === 1 && 
                                (
                                    <English>
                                        {this.createEnglish(englishList[0])}
                                    </English>
                                )
                            }
                        </LanguageInfo>
                        {englishList.length > 1 && 
                            (
                                <LanguageInfo>
                                    {
                                        englishList.map((english) => (
                                            <English key={english}>
                                                {this.createEnglish(english)}
                                            </English>
                                        ))
                                    }
                                </LanguageInfo>
                            )
                        }
                    </GroupAllB>
                    <GroupUser admin={this.props.admin}>
                        <Study admin={this.props.admin}>
                            <IconButton onClick={this.props.onClickFavSubject}>{favIconImage}</IconButton>
                        </Study>
                    </GroupUser>
                    <GroupAllC admin={this.props.admin} Display={Number(this.props.subjectKbn) === Number(SUBJECT_KBN.DELIVERY)}>
                        <Date>{this.props.subject.deliveryMonth + "-" + this.props.subject.deliveryDate + " 配信"}</Date>
                    </GroupAllC>
                </GroupGrid>
                <AdminText admin={this.props.admin}>
                    音声ファイル：{audio}
                </AdminText>
                <Check admin={this.props.admin && this.props.subject.check}>
                    <i className="fas fa-check" />
                </Check>
                <Mask
                    delete={this.props.subject.deleteFlg}
                    publish={this.props.publish}
                    admin={this.props.admin}>
                </Mask>
            </Body>
        );
    }
}

export { Subject };

Subject.propTypes = {
    subject: PropTypes.object.isRequired,
    subjectKbn: PropTypes.string,
    active: PropTypes.bool,
    publish: PropTypes.number,
    select: PropTypes.bool,
    admin: PropTypes.bool,
    studyState: PropTypes.number,
    onClick: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickDelete: PropTypes.func,
    onClickHidden: PropTypes.func,
    onClickFavSubject: PropTypes.func,
};

const Body = styled.div`
    width: 80%;
    max-width: 280px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    padding: 10px;
    margin: 5px;
    background-color: ${props => props.studyState === STUDY_STATE.DONE ? "#F2F8EE" : "#fff"};
    box-shadow: 0 0 3px ${props => props.active || props.select ? "rgba(0, 128, 255, 0.4)" : "rgba(0, 0, 0, 0.2)"};

    margin-top: 0px;
    opacity: 0;
    transition-duration: 0.2s;

    position: relative;
`;

const Date = styled.div`
    font-size: 12px;
`;

const Training = styled.div`
    display: ${props => props.admin ? 'none' : 'flex'};
    width: 100%;
`;

const Bar = styled.p`
    display: ${props => props.admin ? 'none' : 'flex'};
    margin: 1px 1px 3px 1px;
    width: 20%;
    height: 10px;
    background: ${props => (props.color ? props.color : '#bfbfbf')};
`;

const GroupGrid = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 200px 1fr;
   
`;

const GroupAdmin = styled.div`
    display: flex;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: auto;
`;

const GroupAllA = styled.div`
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: ${props => props.admin ? '2' : '1'};
    grid-row-end: auto;
    font-size: 14px;
    font-weight: bold;
`;

const LimitedSubjectSetInfo = styled.div`
    font-weight: normal;
    font-size: 14px;
    color: #888888;
`;

const GroupAllB = styled.div`
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: ${props => props.admin ? '3' : '2'};
    grid-row-end: auto;
`;

const GroupAllC = styled.div`
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: ${props => props.admin ? '4' : '3'};
    grid-row-end: auto;
    display: ${props => props.Display ? "" : "none"};
`;

const GroupUser = styled.div`
    display: flex;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 4;
    justify-content: flex-end;
`;
const Type = styled.div`
    margin-right: 10px;
    display: ${props => props.admin ? '' : 'none'};
`;
const LanguageInfo = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

const Difficulty = styled.div`
    margin: 2.5px 2px;
    width: 50px;
    height: 22px;

    text-align: center;
    color: #000;
    font-size: 16px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #888;
`;

const Source = styled.div`
    margin: 4.5px 2px;
`;

const English = styled.div`
    margin: 4.5px 2px;
`;

const Study = styled.div`
    padding: 0px 0px 5px 0px;
    word-break: keep-all;
    word-wrap: none;
    display: ${props => props.admin ? 'none' : ''};
`;

const AdminText = styled.div`
    display: ${props => props.admin ? '' : 'none'};
`;

const Controls = styled.div`
    display: ${props => props.admin ? 'flex' : 'none'};
    margin-left: 90px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
`;
const IconButton = styled.div`
    margin: 0 5px;
    cursor: pointer;
    color: ${props => props.Color ? props.Color : "#888"};
`;
const Check = styled.div`
    display: ${props => props.admin ? '' : 'none'};
    position: absolute;
    bottom: 5px;
    right: 10px;
    color: #26CFA9;
    font-size: 32px;
    opacity: 0.6;
`;

const Mask = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: ${props => props.admin && (!props.publish || props.delete) ? "0.2" : "0"};
    pointer-events: none;
`;
